import { createAction, props } from "@ngrx/store";
import { TransInquiryTrustFields } from "../../transaction-view/models/TransInquiryTrustFields";
import { PtrsResponse } from "../models/ptrs/PtrsApiResponse";
import { ServiceError } from "../models/shared/ServiceError";

export const callPtrs = createAction(
    '[Create Request Page/API] Calling PTRS Service',
    props<{ accountId: string }>()
);

export const callPtrsSuccess = createAction(
    '[Create Request Page/API] Call to PTRS Service Succeeded',
    props<PtrsResponse>()
)

export const callPtrsFailure = createAction(
    '[Create Request Page/API] Call to PTRS Service Failed',
    props<ServiceError>()
)

export const transInquiryCallSuccessful = createAction(
    '[Transaction View - PTRS Inquiry] Trans Inquiry call successful',
    props<{ transInquiryResponse: TransInquiryTrustFields }>()
);

export const transInquiryCallFailed = createAction(
    '[Transaction View - PTRS Inquiry] Trans Inquiry call failed',
    props<ServiceError>()
);